import { createContext, useContext, useState, useEffect } from "react"
import { createAppKit } from "@reown/appkit/react"
import { WagmiProvider } from "wagmi"
import { bsc} from "@reown/appkit/networks"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi"

const WalletContext = createContext()

export const useWallet = () => {
  const context = useContext(WalletContext)
  if (!context) {
    throw new Error("useWallet must be used within a WalletProvider")
  }
  return context
}

// Project ID from environment
const projectId = process.env.REACT_APP_REOWN_PROJECT_ID || '9ab792ef99639629d13956436a4e6785'

// Metadata for the dApp
const metadata = {
  name: 'NFT Marketplace',
  description: 'Buy and sell unique NFTs',
  url: 'https://nftmarketplace.com',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

// Network configuration with custom RPC
const networks = [
  {
    ...bsc,
    rpcUrls: {
      default: {
        http: [process.env.REACT_APP_RPC_URL ||'https://bsc-dataseed.binance.org/']
      }
    }
  }
]

// Create Wagmi Adapter
const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: false,
})

// Create AppKit modal
createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: true,
  },
})

const queryClient = new QueryClient()

// Internal component to track wallet state
const WalletStateTracker = ({ children }) => {
  const [isConnected, setIsConnected] = useState(false)
  const [address, setAddress] = useState("")
  const [chainId, setChainId] = useState(null)

  const value = {
    isConnected,
    address,
    chainId,
    setIsConnected,
    setAddress,
    setChainId,
  }

  return (
    <WalletContext.Provider value={value}>
      {children}
    </WalletContext.Provider>
  )
}

export const WalletProvider = ({ children }) => {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <WalletStateTracker>
          {children}
        </WalletStateTracker>
      </QueryClientProvider>
    </WagmiProvider>
  )
}

// Export wagmi config for use in other files
export const config = wagmiAdapter.wagmiConfig
